var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningColor = function SvgWarningColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.057 0 0 8.057 0 18a17.966 17.966 0 0 0 6.073 13.486A17.974 17.974 0 0 0 18 36c4.578 0 8.752-1.708 11.927-4.521A17.94 17.94 0 0 0 36 18c0-9.943-8.058-18-18-18Z",
    fill: "url(#warning-color_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 28.056c-5.711 0-10.459-4.748-10.459-10.46 0-5.721 4.737-10.458 10.449-10.458 5.721 0 10.469 4.737 10.469 10.459 0 5.711-4.737 10.459-10.459 10.459Zm0-1.744a8.682 8.682 0 0 0 8.716-8.715A8.691 8.691 0 0 0 17.99 8.88c-4.84 0-8.696 3.876-8.696 8.716A8.674 8.674 0 0 0 18 26.312Zm-.01-6.87c-.513 0-.8-.287-.81-.81l-.134-5.424c-.01-.523.38-.902.934-.902.543 0 .953.39.943.912l-.154 5.414c-.01.534-.297.81-.78.81Zm0 3.333c-.595 0-1.108-.482-1.108-1.066 0-.585.503-1.067 1.108-1.067.595 0 1.097.472 1.097 1.067 0 .594-.513 1.066-1.097 1.066Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "warning-color_svg__a",
    x1: 0.969,
    y1: 0,
    x2: 0.969,
    y2: 34.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F69D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB5D2C"
  })))));
};
export default SvgWarningColor;